import { StaticPageContent } from "@components/Shared/model/StaticPageContent";
import { FamilyCompaniesContent } from "@components/FamilyOfCompanies/Content";
import { LanguageContent } from "@components/Shared/model/LanguageContent";
import { MetaContent } from "@components/Shared/model/MetaHelmet";
import { FamilyHeroContent } from "@components/FamilyOfCompanies/FamilyHeroContent";

export const MetaObject: LanguageContent<MetaContent> = {
	en: {
		title: "Ryerson Family of Companies - Ryerson",
		description:
			"The Ryerson Family of Companies consists of multiple brands within the organization, each of which offers distinct value and expertise that allow us to serve our customers better.",
		url: `/about-us/family-of-companies`,
		imageUrl: "/images/family-of-companies/FoC.png",
		company: true,
	},
	fr: {
		title: "Ryerson Family of Companies - Ryerson",
		description:
			`La famille d'entreprises Ryerson comprend plusieurs marques au sein de l'organisation, 
            chacune offrant une valeur et une expertise distincte, afin de mieux servir nos clients`,
		url: `/about-us/family-of-companies`,
		imageUrl: "/images/family-of-companies/FoC.png",
		company: true,
	},
	es: {
		title: "Ryerson Family of Companies - Ryerson",
		description:
			`La Familia de compañías Ryerson consiste en varias marcas dentro de la organización, 
            todas las cuales ofrecen valor y conocimiento técnico diversos que nos permiten servir mejor 
            a nuestros clientes`,
		url: `/about-us/family-of-companies`,
		imageUrl: "/images/family-of-companies/FoC.png",
		company: true,
	},
};

export const PageContent: StaticPageContent = {
	meta: MetaObject,
	content: [FamilyHeroContent, FamilyCompaniesContent],
};
